import './TimeCard.css';
import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';

export const TimeCard = ({ title, value }) => {
console.log("🚀 ~ TimeCard ~ value:", value)

    const [primaryColor, secondaryColor] = defaultColors || ['#71b4b7', '#283845'];

    return (
        <div className="time-card" style={{ borderColor: secondaryColor }}>
            <div className="time-card__value" style={{ color: primaryColor }}>
                {value}
            </div>
            <div className="time-card__title">{title}</div>
        </div>
    );
};
